import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import intl from 'react-intl-universal';
import PageTitle from 'Molecules/PageTitle/PageTitle';
import TableView from './views/TableView';
import V2TableView from './views/v2/TableView';
import V3TableView from './views/v3/TableView';
import CreateCentralizedTaskModal from './components/CreateCentralizedTaskModal';
import CreateTaskModal from 'Pages/TasksListPage/components/v2/CreateTaskModal/CreateTaskModal';
import { selectUserType, selectIsUserFacilitator } from 'state/User/userSlice';
import { USER_TYPES } from 'utils/constants';
import { useFlags } from 'launchdarkly-react-client-sdk';

const TasksListPage = () => {
  const { newTaskListViews = false, newTeamTaskTable = false } = useFlags();
  const userType = useSelector(selectUserType);
  const isUserFacilitator = useSelector(selectIsUserFacilitator);

  useEffect(() => {
    localStorage.removeItem('fromV2TasksUrl');
  }, []);

  const canAddTasks = useMemo<boolean>(
    () => userType !== USER_TYPES.BUSINESS && userType !== USER_TYPES.EXTERNAL,
    [userType]
  );

  return (
    <div className='flex flex-col h-full'>
      <PageTitle
        titleComponent={intl.get('TASKS_LIST_PAGE.TITLE')}
        headerChildren={
          canAddTasks &&
          (newTaskListViews ? (
            <CreateTaskModal isUserFacilitator={isUserFacilitator} />
          ) : (
            <CreateCentralizedTaskModal />
          ))
        }
      />
      {!newTaskListViews && <TableView />}
      {newTaskListViews && !newTeamTaskTable && (
        <V2TableView isLDTypeUser={userType === USER_TYPES.L_D} />
      )}
      {newTaskListViews && newTeamTaskTable && (
        <V3TableView isLDTypeUser={userType === USER_TYPES.L_D} />
      )}
    </div>
  );
};

export default TasksListPage;
